function extractIdentifierFromCommandResponse(response: unknown, identifierKey: string): string | undefined {
	if (response === null || typeof response !== 'object' || !('data' in response)) {
		return undefined;
	}

	const payload = response.data;
	if (payload === null || typeof payload !== 'object' || !('data' in payload)) {
		return undefined;
	}

	const data = payload.data;
	if (data === null || typeof data !== 'object' || !(identifierKey in data)) {
		return undefined;
	}

	const identifier = (data as Record<string, unknown>)[identifierKey];
	if (typeof identifier === 'string') {
		return identifier;
	}

	if (typeof identifier === 'number' && Number.isFinite(identifier)) {
		return String(identifier);
	}

	return undefined;
}

export function extractMailDraftIdFromCommandResponse(response: unknown): string | undefined {
	return extractIdentifierFromCommandResponse(response, 'draftId');
}

export function extractMailTemplateIdFromCommandResponse(response: unknown): string | undefined {
	return extractIdentifierFromCommandResponse(response, 'templateId');
}
